import { render, staticRenderFns } from "./ProductionProgressBar.vue?vue&type=template&id=f4784ac2"
import script from "./ProductionProgressBar.vue?vue&type=script&lang=js"
export * from "./ProductionProgressBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports